module.exports = __webpack_public_path__ + "assets/787379016f065601d8faa018db073620.png";